import React from 'react';

/** Shared "Continue with Google" CTA for sign-in and sign-up (FR-002 / FR-050). */
export default function GoogleSignInButton({ onClick, children = 'Continue with Google' }) {
  return (
    <button type="button" onClick={onClick} style={googleBtnStyle}>
      <GoogleGlyph />
      {children}
    </button>
  );
}

function GoogleGlyph() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
      <path fill="#4285F4" d="M22 12.2c0-.7-.06-1.4-.18-2H12v3.8h5.6a4.8 4.8 0 01-2.08 3.15v2.6h3.36C20.84 17.94 22 15.34 22 12.2z" />
      <path fill="#34A853" d="M12 22c2.7 0 5-.9 6.66-2.43l-3.36-2.6c-.93.62-2.12.99-3.3.99-2.54 0-4.7-1.7-5.46-4H3.1v2.5A10 10 0 0012 22z" />
      <path fill="#FBBC04" d="M6.54 13.96c-.2-.6-.31-1.25-.31-1.96s.11-1.36.31-1.96V7.55H3.1A10 10 0 002 12c0 1.6.38 3.12 1.1 4.45l3.44-2.49z" />
      <path fill="#EA4335" d="M12 5.6c1.46 0 2.78.5 3.81 1.5l2.85-2.86C16.96 2.7 14.66 2 12 2A10 10 0 003.1 7.55l3.44 2.49C7.3 7.3 9.46 5.6 12 5.6z" />
    </svg>
  );
}

const googleBtnStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  width: '100%',
  height: '52px',
  padding: '0 22px',
  borderRadius: '999px',
  // Neutral-300 stroke reads clearly on white auth panels (--line is too faint).
  border: '1.5px solid #d4d4d8',
  background: 'var(--paper)',
  boxShadow: 'var(--shadow-sm)',
  color: 'var(--ink)',
  fontSize: '14.5px',
  fontWeight: 500,
  cursor: 'pointer',
  fontFamily: 'var(--font)',
};
